import React, { useState, useEffect } from "react";
import Sidebar from '../../composant_reutilisable/sidebar';
import Navbar from "../../composant_reutilisable/navbar";
import useAuth from '../../composant_reutilisable/useAuth';
import { Link } from "react-router-dom";
import { Button, Spinner, Modal } from "react-bootstrap";
import { FaCalendarAlt, FaMapMarkerAlt, FaUser, FaClock, FaTag, FaEye, FaImage, FaUsers, FaBan, FaCheckCircle } from "react-icons/fa";
import { useLocation } from 'react-router-dom';
import Footer from "../../composant_reutilisable/footer";
import { staticEventData } from "./staticEventData";

const ConfigurerEvenement = () => {
    useAuth();
    const location = useLocation();
    const [evenement, setEvenement] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const user_id = localStorage.getItem('userId');
    const { evenement_id } = location.state || {};
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [showModal, setShowModal] = useState(false);

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 3000);
    };

    const handleShowModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    // Récupération des détails de l'événement
    const fetchEvenementDetails = async () => {
        if (!evenement_id) {
            setError("Aucun identifiant d'événement fourni");
            setLoading(false);
            return;
        }

        setLoading(true);

        // 🔧 TEST STATIQUE - Commenter l'appel API
        // Simuler un délai de chargement
        setTimeout(() => {
            setEvenement(staticEventData);
            setLoading(false);
            setError(null);
        }, 500);

        // try {
        //     setLoading(true);
        //     const token = localStorage.getItem('access_token');
        //     const response = await fetch(process.env.REACT_APP_HOTE + `api/details-evenement/${evenement_id}/`, {
        //         headers: {
        //             'Authorization': `Bearer ${token}`,
        //             'Content-Type': 'application/json',
        //         },
        //     });

        //     if (response.ok) {
        //         const data = await response.json();
        //         setEvenement(data.data || data);
        //         setError(null);
        //     } else {
        //         const errorData = await response.json();
        //         setError(errorData.message || "Erreur lors du chargement des détails");
        //     }
        // } catch (error) {
        //     console.error('Erreur réseau:', error);
        //     setError("Impossible de charger les détails de l'événement");
        // } finally {
        //     setLoading(false);
        // }
    };

    useEffect(() => {
        if (evenement_id) {
            fetchEvenementDetails();
        }
    }, [evenement_id]);


    // Bloquer/Débloquer événement
    const handleBloquerEvenement = async () => {
        try {
            const token = localStorage.getItem('access_token');
            console.log("🔍 Envoi requête pour evenement_id:", evenement_id);

            const response = await fetch(`${process.env.REACT_APP_HOTE}api/suspendre-evenement/${evenement_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            const data = await response.json();
            console.log("📦 Réponse reçue:", data);

            if (response.ok && data.success) {
                // Mise à jour de l'événement avec le nouveau statut
                setEvenement(prev => ({
                    ...prev,
                    statut_evenement: data.nouveau_statut
                }));
                setShowModal(false);
                showAlert(`✅ ${data.message}`);
            } else {
                showAlert(`❌ Erreur : ${data.message || "Une erreur est survenue"}`);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert("❌ Une erreur s'est produite. Veuillez réessayer.");
        }
    };

    // Formatage des dates
    const formatDate = (dateString) => {
        if (!dateString) return "—";
        const date = new Date(dateString);
        return date.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    // Badge statut
    const getStatutBadge = () => {
        const statut = evenement?.statut_evenement;
        switch (statut) {
            case '1':
                return { texte: 'En cours', couleur: 'success', icon: <FaCheckCircle className="me-1" /> };
            case '2':
                return { texte: 'Publié', couleur: 'primary', icon: <FaClock className="me-1" /> };
            case '6':
                return { texte: 'Suspendu', couleur: 'danger', icon: <FaBan className="me-1" /> };
            case '4':
                return { texte: 'Terminé', couleur: 'secondary', icon: <FaClock className="me-1" /> };
            case '5':
                return { texte: 'Archivé', couleur: 'warning', icon: <FaBan className="me-1" /> };
            default:
                return { texte: 'Actif', couleur: 'success', icon: <FaCheckCircle className="me-1" /> };
        }
    };

    const statutBadge = getStatutBadge();
    const estSuspendu = evenement?.statut_evenement === '6';

    // Composant Détail
    const Detail = ({ label, value, icon }) => (
        <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
            <span className="text-muted d-flex align-items-center">
                {icon && <span className="me-2">{icon}</span>}
                {label}
            </span>
            <span className="fw-semibold">{value || ""}</span>
        </div>
    );

    // Rendu des collaborateurs
    const renderCollaborateurs = () => (
        evenement?.collaborateurs?.length ? (
            <div className="table-responsive">
                <table className="table table-bordered table-hover align-middle">
                    <thead className="table-light">
                        <tr>
                            <th>Réf. compte</th>
                            <th>Nom & Prénom</th>
                            <th>Email</th>
                            <th>Téléphone</th>
                            <th>Rôle</th>
                            <th>Statut</th>
                        </tr>
                    </thead>
                    <tbody>
                        {evenement.collaborateurs.map(c => (
                            <tr key={c.id}>
                                <td><code>{c.ref_compte}</code></td>
                                <td>{c.nom} {c.prenoms}</td>
                                <td>{c.email}</td>
                                <td>{c.telephone || "—"}</td>
                                <td>
                                    <span className={`badge bg-${c.type_collaboration === '1' ? 'info' : c.type_collaboration === '2' ? 'primary' : 'success'}`}>
                                        {c.type_label}
                                    </span>
                                </td>
                                <td>
                                    <span className={`badge bg-${c.statut_collaboration === '2' ? 'success' : 'warning'}`}>
                                        {c.statut_label || (c.statut_collaboration === '2' ? 'Actif' : 'Invité')}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        ) : (
            <div className="text-center text-muted py-5">
                <FaUsers size={40} className="mb-3 opacity-50" />
                <p>Aucun collaborateur assigné à cet événement</p>
            </div>
        )
    );

    const [expanded, setExpanded] = useState(false);
    const MAX_LENGTH = 150;

    const DetailLongText = ({ label, value, icon }) => {
        const [isExpanded, setIsExpanded] = useState(false);

        if (!value) return null;

        const needsExpand = value.length > MAX_LENGTH;
        const displayText = isExpanded ? value : value.slice(0, MAX_LENGTH) + (needsExpand ? '...' : '');

        return (
            <div className="mt-1 pt-2">
                <div className="d-flex align-items-start gap-2">
                    {icon && <span className="text-muted mt-1 flex-shrink-0">{icon}</span>}
                    <div className="w-100">
                        <span className="text-muted d-block mb-1" style={{ fontSize: '0.85rem' }}>{label}</span>
                        <p className="mb-1" style={{
                            fontSize: '0.9rem',
                            lineHeight: '1.5',
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word'
                        }}>
                            {displayText}
                        </p>
                        {needsExpand && (
                            <button
                                onClick={() => setIsExpanded(!isExpanded)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: '#0d6efd',
                                    fontSize: '0.8rem',
                                    padding: '0',
                                    cursor: 'pointer'
                                }}
                            >
                                {isExpanded ? 'Voir moins' : 'Voir plus'}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    // // Affichage de l'erreur
    // if (error) {
    //     return (
    //         <div id="wrapper">
    //             <Sidebar user_id={user_id} />
    //             <div id="page-wrapper" className="gray-bg">
    //                 <Navbar />
    //                 <div className="wrapper wrapper-content">
    //                     <div className="alert alert-danger text-center py-5">
    //                         <h4>Erreur</h4>
    //                         <p>{error}</p>
    //                         <button className="btn btn-primary" onClick={fetchEvenementDetails}>
    //                             Réessayer
    //                         </button>
    //                     </div>
    //                 </div>
    //                 <Footer />
    //             </div>
    //         </div>
    //     );
    // }

    // if (!evenement) {
    //     return (
    //         <div id="wrapper">
    //             <Sidebar user_id={user_id} />
    //             <div id="page-wrapper" className="gray-bg">
    //                 <Navbar />
    //                 <div className="wrapper wrapper-content">
    //                     <div className="alert alert-warning text-center py-5">
    //                         <h4>Aucune donnée</h4>
    //                         <p>Aucun événement trouvé</p>
    //                     </div>
    //                 </div>
    //                 <Footer />
    //             </div>
    //         </div>
    //     );
    // }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />

                {/* En-tête */}
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h2 className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center">
                                <FaCalendarAlt size={25} className="me-2" />
                                Détails de l’évènement
                            </div>
                        </h2>
                        <small>Consultez les détails d’un évènement créé sur la plateforme.</small>
                        <div className="d-flex justify-content-end mt-2">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/Admin">Administration</Link></li>
                                <li className="breadcrumb-item"><Link to="/Liste-evenement">Listes évènements</Link></li>
                                <li className="breadcrumb-item active">Détail évènement</li>
                            </ol>
                        </div>
                    </div>
                </div>

                {alert.message && (
                    <div className={`mt-3 alert alert-${alert.type}`}>
                        {alert.message}
                    </div>
                )}

                <div className="wrapper wrapper-content animated fadeInRight mt-4 mb-4">
                    <div className="ibox-content">

                        {loading ? (
                            <div className="text-center py-5">
                                <Spinner animation="border" variant="primary" />
                                <p className="mt-3 text-muted">Chargement des dét  ails de l'événement...</p>
                            </div>
                        ) : (
                            <>
                                {/* HEADER */}
                                <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
                                    <div>
                                        <h2 className="mb-2">{evenement.titre}</h2>
                                        <span className={`badge bg-${statutBadge.couleur} fs-6 px-3 py-2`}>
                                            {statutBadge.icon} {statutBadge.texte}
                                        </span>
                                    </div>
                                    <button
                                        className={`btn btn-${estSuspendu ? 'warning' : 'danger'} mt-2 mt-sm-0`}
                                        onClick={handleShowModal}
                                    >
                                        {estSuspendu ? 'Réactiver l’évènement' : 'Suspendre l’évènement'}
                                    </button>
                                </div>

                                <div className="row">
                                    {/* COLONNE GAUCHE - IMAGE BANNIÈRE */}
                                    <div className="col-md-6 d-flex flex-column">
                                        <div className="card mb-4 shadow-sm flex-grow-1">
                                            <div className="card-header text-white fw-bold" style={{ backgroundColor: '#621d6be1' }}>
                                                Photo de l'événement
                                            </div>
                                            <div className="card-body text-center p-0 d-flex align-items-center justify-content-center" style={{ minHeight: "300px" }}>
                                                {evenement.photo_evenement ? (
                                                    <img
                                                        src={evenement.photo_evenement}
                                                        alt="Bannière"
                                                        className="img-fluid rounded w-100"
                                                        style={{ maxHeight: "400px", objectFit: "cover" }}
                                                    />
                                                ) : (
                                                    <div className="text-center text-muted py-5">
                                                        <FaImage size={50} className="mb-3 opacity-50" />
                                                        <p>Aucune image de bannière</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Carte description */}
                                        <div className="card mb-4 shadow-sm flex-grow-1">
                                            <div className="card-header text-white fw-bold" style={{ backgroundColor: '#621d6be1' }}>
                                                Description
                                            </div>
                                            <div className="card-body">
                                                <DetailLongText value={evenement.description} />
                                            </div>
                                        </div>
                                    </div>

                                    {/* COLONNE DROITE */}
                                    <div className="col-md-6 d-flex flex-column">
                                        {/* Carte informations générales */}
                                        <div className="card mb-4 shadow-sm flex-grow-1">
                                            <div className="card-header text-white fw-bold" style={{ backgroundColor: '#621d6be1' }}>
                                                Informations générales
                                            </div>
                                            <div className="card-body">
                                                <Detail label="Référence de l'événement" value={evenement.ref_evenement} icon={<FaTag size={14} />} />
                                                <Detail label="Catégorie" value={evenement.categorie?.nom} icon={<FaTag size={14} />} />
                                                <Detail label="Organisateur" value={evenement.organisateur?.pseudo} icon={<FaUser size={14} />} />
                                                <Detail label="Créé le" value={formatDate(evenement.date_creation)} icon={<FaClock size={14} />} />
                                            </div>
                                        </div>

                                        {/* Carte informations pratiques */}
                                        <div className="card mb-4 shadow-sm flex-grow-1">
                                            <div className="card-header text-white fw-bold" style={{ backgroundColor: '#621d6be1' }}>
                                                Informations pratiques
                                            </div>
                                            <div className="card-body">
                                                <Detail label="Lieu" value={evenement.nom_lieu} icon={<FaMapMarkerAlt size={14} />} />
                                                <Detail label="Date début" value={formatDate(evenement.date_debut_evenement)} icon={<FaClock size={14} />} />
                                                <Detail label="Date fin" value={formatDate(evenement.date_fin_evenement)} icon={<FaClock size={14} />} />

                                                <DetailLongText
                                                    label="Description du lieu"
                                                    value={evenement.description_lieu}
                                                    icon={<FaMapMarkerAlt size={14} />}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>

                        )}
                    </div>
                </div>

                <Footer />
            </div>

            {/* Modal de confirmation */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Êtes-vous sûr de vouloir {estSuspendu ? 'réactiver' : 'suspendre'} l'évenement  ?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        <strong>Annuler</strong>

                    </Button>
                    <Button variant="success" onClick={handleBloquerEvenement}>
                        <strong> {estSuspendu ? 'Réactiver' : 'Suspendre'}</strong>
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ConfigurerEvenement;